import { ADD_GOAL, REMOVE_GOAL } from '../actions/types';

const INITIAL = null;

export default (state = INITIAL, action) => {

  switch (action.type) {
    case ADD_GOAL : {
      return action.payload;
    }
    case REMOVE_GOAL : {
      return INITIAL;
    }
    default : {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/goal_reducer.js